import { IntermediatePlateInfoState, SourcePlateInfoState } from "./state";

export const getSourcePlateInfoState = (): SourcePlateInfoState => {
  return {
    plateBarcode: "",
    labwareTypeCode: "",
    operatingVol: 0,
    rows: [],
    cols: [],
    wellInfo: [],
    discardSourcePlate: -1,
  };
};

export const getIntermediatePlateInfoState = (): IntermediatePlateInfoState => {
  return {
    plateBarcode: "",
    labwareTypeCode: "",
    operatingVol: 0,
    resuspensionVol: 0,
    rows: [],
    cols: [],
  };
};
